import { render, staticRenderFns } from "./FunnelError.vue?vue&type=template&id=d6da268c"
import script from "./FunnelError.vue?vue&type=script&lang=js"
export * from "./FunnelError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports